import React from "react";
import ALLRouter from "./ALLrouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QuoteProvider } from "./pages/quote-form/QuoteContext";

function App() {

  return (
    <>
    <QuoteProvider>
      <ToastContainer />
      <ALLRouter />
    </QuoteProvider>
    </>
  );
}

export default App;















// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// import LoadingScreen from './LoadingScreen';
// import LoginPage from './pages/auth/LoginPage';
// import ForgotPassword from './pages/auth/ForgotPassword';
// import ResetPassword from './pages/auth/ResetPassword';
// import Sidebar from './components/Sidebar';
// import Dashboard from './pages/dashboard';
// import { useAuth } from "./context/UserContext"; //
// import Header from './pages/steperform/Header';
// import SummaryTable from './pages/steperform/SummaryTable';
// import TableComponent from './pages/steperform/TableComponent';
// import GetEmail from './GetEmail';

// function App() {
//   // Simulating authentication status
//   const { currentUser } = useAuth(); // Assume this hook provides the `currentUser`

//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes */}
//         {/* {!currentUser ? ( */}
//           <>
//             <Route path="/" element={<LoginPage />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route path="/qoute" element={<Header />} />
//             {/* <Route path="/email" element={<GetEmail />} /> */}
//             {/* <Route path="/summary" element={<SummaryTable />} /> */}
//             {/* <Route path="/table" element={<TableComponent />} /> */}
//           </>
//         {/* ) : ( */}
//           // Protected Routes (Sidebar with Navigation)
//           <>
//             <Route
//               path="/*"
//               element={
//                 <div className="flex">
//                   <Sidebar />
//                   <div className="flex-grow">
//                     <Routes>
//                       <Route path="/dashboard" element={<Dashboard />} />
//                       <Route path="/plans" element={<div>Plans Page</div>} />
//                       <Route path="/premiums" element={<div>Premiums Page</div>} />
//                       <Route path="/discounts" element={<div>Discounts Page</div>} />
//                       <Route path="/page" element={<div>Quotes Page</div>} />
//                       <Route path="/logout" element={<div>Logout Page</div>} />
//                     </Routes>
//                   </div>
//                 </div>
//               }
//             />
//           </>
//         {/* )} */}

//         {/* Redirect any unknown route */}
//         {/* <Route path="*" element={<Navigate to={currentUser ? '/dashboard' : '/'} />} /> */}
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import React, { lazy, Suspense } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// import LoadingScreen from './LoadingScreen';
// import LoginPage from './pages/auth/LoginPage';
// import ForgotPassword from './pages/auth/ForgotPassword';
// import ResetPassword from './pages/auth/ResetPassword';
// import Sidebar from './components/Sidebar';
// import Dashboard from './pages/dashboard';
// import { useAuth } from "./context/UserContext";

// const Header = lazy(() => import('../src/pages/steperform/Header'));

// function App() {
//   const { currentUser } = useAuth(); // Ensure context is provided

//   return (
//     <Router>
//       <Routes>
//         {!currentUser ? (
//           <>
//             <Route path="/" element={<LoginPage />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route
//               path="/qoute"
//               element={
//                 <Suspense fallback={<> <LoadingScreen /></>}>
//                   <Header />
//                 </Suspense>
//               }
//             />
//           </>
//         ) : (
//           <Route
//             path="/*"
//             element={
//               <div className="flex">
//                 <Sidebar />
//                 <div className="flex-grow">
//                   <Routes>
//                     <Route path="/dashboard" element={<Dashboard />} />
//                     <Route path="/plans" element={<div>Plans Page</div>} />
//                     <Route path="/premiums" element={<div>Premiums Page</div>} />
//                     <Route path="/discounts" element={<div>Discounts Page</div>} />
//                     <Route path="/page" element={<div>Quotes Page</div>} />
//                     <Route path="/logout" element={<div>Logout Page</div>} />
//                   </Routes>
//                 </div>
//               </div>
//             }
//           />
//         )}
//         <Route path="*" element={<Navigate to={currentUser ? '/dashboard' : '/'} />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
